import React, { Component } from "react";
import { Link } from "react-router-dom";
import HelperClass from "../../../config/helperClass";
import { listActivities } from "./api/leads_api";

const auth = new HelperClass();

const PAGE_SIZE = 25;

// All distinct types written by writeActivity() in the agent BE
const ACTIVITY_TYPES = [
  { value: "",        label: "All Types" },
  { value: "stage",   label: "Stage Change" },
  { value: "system",  label: "System" },
  { value: "note",    label: "Note" },
  // { value: "call",    label: "Call" },
  // { value: "email",   label: "Email" },
  // { value: "task",    label: "Task" },
];

const TYPE_STYLES = {
  stage:  { color: "#1c5bde", bg: "#e8eefb", icon: "ni ni-swap" },
  system: { color: "#6b7280", bg: "#f3f4f6", icon: "ni ni-setting" },
  note:   { color: "#d97706", bg: "#fef3c7", icon: "ni ni-notes" },
  // call:   { color: "#1a7a4a", bg: "#e6f4ec", icon: "ni ni-call" },
  // email:  { color: "#0369a1", bg: "#e0f2fe", icon: "ni ni-mail" },
  // task:   { color: "#6b3fa0", bg: "#f0eafa", icon: "ni ni-check-circle" },
};

function typeStyle(type) {
  return TYPE_STYLES[String(type).toLowerCase()] || { color: "#6b7280", bg: "#f3f4f6", icon: "ni ni-activity" };
}

function relativeTime(dateStr) {
  if (!dateStr) return "—";
  var now = new Date();
  var dt  = new Date(dateStr);
  var sec = Math.floor((now - dt) / 1000);
  if (sec < 60)   return "just now";
  if (sec < 3600) return Math.floor(sec / 60) + "m ago";
  if (sec < 86400) return Math.floor(sec / 3600) + "h ago";
  if (sec < 604800) return Math.floor(sec / 86400) + "d ago";
  return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export default class ActivitiesFeed extends Component {
  state = {
    mobileMenuOpen: false,
    rows: [],
    total: 0,
    page: 1,
    totalPages: 1,
    loading: true,
    error: "",
    // filters
    typeFilter: "",
    search: "",
    searchInput: "",   // controlled input, only applied on Enter / button
  };

  componentDidMount() {
    this.fetch(1);
    this._onResize = () => { if (window.innerWidth >= 576) this.setState({ mobileMenuOpen: false }); };
    window.addEventListener("resize", this._onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._onResize);
  }

  fetch = async (page, overrides) => {
    this.setState({ loading: true, error: "" });
    var s = Object.assign({}, this.state, overrides || {});
    try {
      var r = await listActivities(auth.getAccount(), auth.getToken(), {
        page: page,
        page_size: PAGE_SIZE,
        type:   s.typeFilter || undefined,
        search: s.search     || undefined,
      });
      var d = r && r.data;
      if (d && d.status === 200) {
        this.setState({
          rows: d.data.rows || [],
          total: d.data.total || 0,
          page: d.data.page || page,
          totalPages: d.data.total_pages || 1,
          loading: false,
        });
      } else {
        this.setState({ loading: false, error: "Failed to load activities." });
      }
    } catch (e) {
      this.setState({ loading: false, error: "Network error loading activities." });
    }
  };

  onTypeChange = (val) => {
    this.setState({ typeFilter: val, page: 1 }, function() { this.fetch(1); }.bind(this));
  };

  onSearchSubmit = (e) => {
    if (e) e.preventDefault();
    this.setState({ search: this.state.searchInput, page: 1 }, function() { this.fetch(1); }.bind(this));
  };

  onSearchClear = () => {
    this.setState({ search: "", searchInput: "", page: 1 }, function() { this.fetch(1); }.bind(this));
  };

  goToPage = (p) => {
    if (p < 1 || p > this.state.totalPages || p === this.state.page) return;
    this.setState({ page: p }, function() { this.fetch(p); }.bind(this));
  };

  renderPagination() {
    var { page, totalPages, total, rows } = this.state;
    if (totalPages <= 1 && rows.length === 0) return null;
    var start = (page - 1) * PAGE_SIZE + 1;
    var end   = Math.min(page * PAGE_SIZE, total);

    // build page number window: show up to 5 pages around current
    var pages = [];
    var lo = Math.max(1, page - 2);
    var hi = Math.min(totalPages, page + 2);
    for (var i = lo; i <= hi; i++) pages.push(i);

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 16, flexWrap: "wrap", gap: 8 }}>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          {total > 0 ? "Showing " + start + "–" + end + " of " + total + " activities" : "No results"}
        </div>
        <nav>
          <ul className="pagination pagination-sm" style={{ margin: 0 }}>
            <li className={"page-item" + (page === 1 ? " disabled" : "")}>
              <button className="page-link" onClick={function() { this.goToPage(page - 1); }.bind(this)}>&laquo;</button>
            </li>
            {lo > 1 && (
              <>
                <li className="page-item"><button className="page-link" onClick={function() { this.goToPage(1); }.bind(this)}>1</button></li>
                {lo > 2 && <li className="page-item disabled"><span className="page-link">…</span></li>}
              </>
            )}
            {pages.map(function(p) {
              return (
                <li key={p} className={"page-item" + (p === page ? " active" : "")}>
                  <button className="page-link" onClick={function() { this.goToPage(p); }.bind(this)}>{p}</button>
                </li>
              );
            }.bind(this))}
            {hi < totalPages && (
              <>
                {hi < totalPages - 1 && <li className="page-item disabled"><span className="page-link">…</span></li>}
                <li className="page-item"><button className="page-link" onClick={function() { this.goToPage(totalPages); }.bind(this)}>{totalPages}</button></li>
              </>
            )}
            <li className={"page-item" + (page === totalPages ? " disabled" : "")}>
              <button className="page-link" onClick={function() { this.goToPage(page + 1); }.bind(this)}>&raquo;</button>
            </li>
          </ul>
        </nav>
      </div>
    );
  }

  render() {
    var { rows, total, loading, error, typeFilter, searchInput, search } = this.state;

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">

              {/* ── header ── */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">Sales CRM — Activity Feed</h3>
                    <div className="nk-block-des text-soft">
                      <p>All pipeline activity across every lead — stage changes, notes, calls, and tasks.</p>
                    </div>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentActivity">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a href="#" className="btn btn-icon btn-trigger toggle-expand mr-n1" data-target="activityMenu">
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div className="toggle-expand-content" data-content="activityMenu">
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <Link to="/crm_leads" className="btn btn-info" style={{ color: "#fff" }}>
                              <em className="icon ni ni-list"></em>&nbsp;<span>All Leads</span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── filters bar ── */}
              <div className="card card-bordered mb-3">
                <div className="card-inner" style={{ padding: "12px 16px" }}>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                    {/* type pills */}
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      {ACTIVITY_TYPES.map(function(t) {
                        var active = typeFilter === t.value;
                        return (
                          <button
                            key={t.value}
                            className={"btn btn-sm " + (active ? "btn-primary" : "btn-outline-light")}
                            onClick={function() { this.onTypeChange(t.value); }.bind(this)}
                          >
                            {t.label}
                          </button>
                        );
                      }.bind(this))}
                    </div>
                    {/* search */}
                    <form onSubmit={this.onSearchSubmit} style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          style={{ paddingRight: search ? 28 : 10, minWidth: 200 }}
                          placeholder="Search activity…"
                          value={searchInput}
                          onChange={function(e) { this.setState({ searchInput: e.target.value }); }.bind(this)}
                        />
                        {search && (
                          <button
                            type="button"
                            onClick={this.onSearchClear}
                            style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, color: "#9ca3af", fontSize: 14 }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </button>
                        )}
                      </div>
                      <button type="submit" className="btn btn-sm btn-primary">
                        <em className="icon ni ni-search"></em>
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* ── error ── */}
              {error && (
                <div className="alert alert-danger" style={{ marginBottom: 12 }}>
                  {error} <button className="btn btn-sm btn-danger" onClick={function() { this.fetch(this.state.page); }.bind(this)}>Retry</button>
                </div>
              )}

              {/* ── loading skeleton ── */}
              {loading && (
                <div style={{ textAlign: "center", padding: "60px 0" }}>
                  <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                  <span style={{ marginLeft: 10, color: "#888" }}>Loading activities…</span>
                </div>
              )}

              {/* ── feed ── */}
              {!loading && (
                <div className="card card-bordered">
                  <div className="card-inner" style={{ padding: 0 }}>
                    {rows.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
                        <em className="icon ni ni-activity" style={{ fontSize: 40, display: "block", marginBottom: 12 }}></em>
                        No activities found.
                        {(typeFilter || search) && (
                          <div style={{ marginTop: 8 }}>
                            <button className="btn btn-sm btn-outline-light"
                              onClick={function() { this.setState({ typeFilter: "", search: "", searchInput: "" }, function() { this.fetch(1); }.bind(this)); }.bind(this)}>
                              Clear filters
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <ul className="list-unstyled" style={{ margin: 0 }}>
                        {rows.map(function(a, idx) {
                          var ts = typeStyle(a.type);
                          var isLast = idx === rows.length - 1;
                          return (
                            <li
                              key={a.id}
                              style={{
                                display: "flex", gap: 14, padding: "14px 20px",
                                borderBottom: isLast ? "none" : "1px solid #f0f0f0",
                                alignItems: "flex-start",
                              }}
                            >
                              {/* icon badge */}
                              <div style={{
                                flexShrink: 0,
                                width: 34, height: 34, borderRadius: "50%",
                                background: ts.bg, color: ts.color,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                marginTop: 2,
                              }}>
                                <em className={"icon " + ts.icon} style={{ fontSize: 16 }}></em>
                              </div>

                              {/* content */}
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 2 }}>
                                  {/* type pill */}
                                  <span style={{
                                    fontSize: 10, fontWeight: 700, textTransform: "uppercase",
                                    letterSpacing: "0.05em", padding: "2px 7px", borderRadius: 12,
                                    background: ts.bg, color: ts.color,
                                  }}>{a.type || "activity"}</span>
                                  {/* title */}
                                  <span style={{ fontWeight: 600, fontSize: 13, color: "#111827" }}>{a.title || "(no title)"}</span>
                                </div>
                                {/* body */}
                                {a.body && (
                                  <div style={{ fontSize: 13, color: "#4b5563", marginBottom: 4, marginTop: 2 }}>{a.body}</div>
                                )}
                                {/* lead link + timestamp */}
                                <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                                  {a.lead_uid && (
                                    <Link
                                      to={"/crm_lead_detail/" + a.lead_uid}
                                      style={{ fontSize: 12, color: "#1c5bde", textDecoration: "none", fontWeight: 500 }}
                                    >
                                      <em className="icon ni ni-briefcase" style={{ marginRight: 3 }}></em>
                                      {a.company || a.lead_uid}
                                    </Link>
                                  )}
                                  <span style={{ fontSize: 11, color: "#9ca3af" }}>
                                    <em className="icon ni ni-clock" style={{ marginRight: 3 }}></em>
                                    {relativeTime(a.created_at)}
                                  </span>
                                  {a.created_by && (
                                    <span style={{ fontSize: 11, color: "#9ca3af" }}>
                                      <em className="icon ni ni-user" style={{ marginRight: 3 }}></em>
                                      {a.created_by}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </li>
                          );
                        }.bind(this))}
                      </ul>
                    )}
                  </div>
                  {/* ── pagination ── */}
                  {rows.length > 0 && (
                    <div className="card-inner" style={{ borderTop: "1px solid #f0f0f0" }}>
                      {this.renderPagination()}
                    </div>
                  )}
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

